import { Inject, Injectable } from '@angular/core';
import { DomService } from './dom.service';
import { NavbarUser } from './model/navbar-user';
import waitUntil from 'async-wait-until';
import { from, Observable, of } from 'rxjs';
import { EceNavbar, EceNavbarWindow, UtagData } from './model/ece-navbar';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  constructor(private domService: DomService, @Inject('EnvironmentProvider') private environmentProvider) {}

  initNavbar(urlScript: string, federatedServiceIdentifier: string) {
    if (this.isNavbarAbsent(urlScript)) {
      const navbarConfig = this.domService.getDocument().createElement('script');
      navbarConfig.type = 'text/javascript';
      if (this.environmentProvider.loadingUtag === true) {
        navbarConfig.textContent = `
      var UtagData = {
        version: '1.00', 
        application:'Nous Contacter',
        sous_domaine: 'Espace Client Entreprise',
        univers_affichage: 'assistance entreprise',
       domaine: 'Care',
       sous_domaine: 'Portail',
       code_univers: 'ECE',
       sous_univers: 'Espace Client Entreprise',
       statut_loggue: 'Non logué'     
      };
      // Navbar configuration for production
      var EceNavbarConfig = {
        headerCompleteMode: true,
        federatedServiceIdentifier: '${federatedServiceIdentifier}',
        tracking: { activated: true, serviceUtagDatas: UtagData, manualView: true },
        responsiveDesktop: false,
        headerSticky: false,
      };`;
      } else {
        navbarConfig.textContent = `
          var UtagData = {
              version: '1.00',
              application:'Nous Contacter',
              sous_domaine: 'Espace Client Entreprise',
              univers_affichage: 'assistance entreprise',
              domaine: 'Care',
              sous_domaine: 'Portail',
              code_univers: 'ECE',
              sous_univers: 'Espace Client Entreprise',
              statut_loggue: 'Non logué'
          };
          // Navbar configuration for production
          var EceNavbarConfig = {
              headerCompleteMode: true,
              federatedServiceIdentifier: '${federatedServiceIdentifier}',
              tracking: { activated: false, serviceUtagDatas: UtagData, manualView: true },
              responsiveDesktop: false,
              headerSticky: false,
          };`;
      }

      const navbarScript = this.domService.getDocument().createElement('script');
      navbarScript.type = 'text/javascript';
      navbarScript.src = urlScript;
      this.domService.getDocument().head.appendChild(navbarConfig);
      this.domService.getDocument().head.appendChild(navbarScript);
    }
  }

  addBreadcrumbElement(label: string, link?: string): void {
    this.getEceNavbar()
      .pipe(
        tap((eceNavbar: EceNavbar | null) => {
          if (eceNavbar && eceNavbar.addBreadcrumbElement) {
            if (link) {
              eceNavbar.addBreadcrumbElement(label, link);
            } else {
              eceNavbar.addBreadcrumbElement(label);
            }
          }
        })
      )
      .subscribe();
  }

  removeLastBreadcrumbElement(): void {
    this.getEceNavbar()
      .pipe(
        tap((eceNavbar: EceNavbar | null) => {
          if (eceNavbar && eceNavbar.removeLastBreadcrumbElement) {
            eceNavbar.removeLastBreadcrumbElement();
          }
        })
      )
      .subscribe();
  }

  getUser(): Observable<NavbarUser | null> {
    return this.getEceNavbar().pipe(
      switchMap((eceNavbar: EceNavbar | null) => {
        if (eceNavbar && eceNavbar.getUser) {
          return from(eceNavbar.getUser());
        } else {
          return of(null);
        }
      })
    );
  }

  trackLink(zone: string, name: string, cible?: string): void {
    this.getEceNavbar()
      .pipe(
        tap((eceNavbar: EceNavbar | null) => {
          if (eceNavbar && eceNavbar.trackLink) {
            eceNavbar.trackLink(zone, name, cible);
          }
        })
      )
      .subscribe();
  }

  trackView(): void {
    this.getEceNavbar()
      .pipe(
        tap((eceNavbar: EceNavbar | null) => {
          if (eceNavbar && eceNavbar.trackView) {
            eceNavbar.trackView();
          }
        })
      )
      .subscribe();
  }

  getEceNavbar(): Observable<EceNavbar | null> {
    return from(
      waitUntil(() => (this.domService.getWindow() as unknown as EceNavbarWindow).EceNavbar, {
        timeout: 30000,
      }).catch(() => null)
    );
  }
  setDynamicServiceUtagDatas(utag: UtagData) {
    this.getEceNavbar()
      .pipe(
        tap((eceNavbar: EceNavbar | null) => {
          this.checkAndDosetDynamicServiceUtagDatas(eceNavbar, utag);
        })
      )
      .subscribe();
  }

  async checkAndDosetDynamicServiceUtagDatas(eceNavbar: EceNavbar, utag: UtagData) {
    let loopDelay = 0;
    while (eceNavbar.StateManager.Tracking.utagDataReady === false && loopDelay < 20) {
      await this.delay(100);
      loopDelay++;
    }

    eceNavbar.setDynamicServiceUtagDatas(utag);
  }

  private isNavbarAbsent(navBarUrl: string) {
    return this.domService.getDocument().querySelector(`head > script[src="${navBarUrl}"]`) === null;
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
